module.exports = "<div class=\"hidden-xs col-sm-3 col-md-2\">\n    <div class=\"list-set condensed\">\n        <ul>\n            <li>\n                <a href=\"#\">Carrier P & L</a>\n            </li>\n        </ul>\n    </div>\n</div>\n\n<div class=\"col-sm-9 col-md-10\">\n    \n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sections/sections.component.html
// module id = ./src/app/components/sections/sections.component.html
// module chunks = main